/* eslint-disable react-hooks/rules-of-hooks */
import React, { FC, useEffect, useMemo, useState, useCallback, useRef } from 'react';
import { ProjectsSearchBar } from '../../components/projectsSearchBar/projectsSearchBar';
import { OrganizationsSorting } from '../../components/projectsSearchBar/components/organizationsSorting';
import { useTranslation } from 'react-i18next';
import { FlexBox, useIsMobile, useBreakpoint, Dropdown } from '@brg/ui';
import { API, Designer, Endpoints } from '@brg/api';
import { createGlobalStyle, useTheme } from 'styled-components';
import {
  CoreContainer,
  LayoutConst,
  modalControllerSelector,
  useModal
} from '../../../core';
import { SortingTypeIndex } from '../../constants/sortingType';
import ProjectsButchController from '../../../core/controllers/ProjectsButchControllerUltimate';
import { useEncodedStateFilter, EncodedStateFilter } from '../../components/Filters';
import { flipDisplay } from '../../utils/display'
import useExtraFilter from "../../hooks/useExtraFilter";
import { MobileFilterRow, MobileFilterSort } from '../explore/exploreView';
import { SortIcon } from 'shared/icons';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { CreateLinkTo, LinkTo } from 'shared/constants/linkTo';
import {
  BottomGroupWrapper,
  ProjectControllerWrapper,
  SearchBarBox,
  BottomOuterContainer,
  GlobalChangeColorWrapper,
  DescriptionExtra,
} from '../explore/styles';
import useQueryState from 'shared/hooks/useQueryState';
import { ProjectSearchBarSorting } from '../../components/projectsSearchBar/components/projectSearchBarSorting';
import { useDispatch, useSelector } from 'react-redux';
import { AppTester } from 'supporting';
import { bProfile, useProfile } from '@brg/auth';
import { convertSorting } from "./model/convertSorting";
import { useGetCurrentTeam } from "../../hooks/useGetCurrentTeam";
import { ProjectsGridNew } from "../../components/grids";
import { EmblemContainer } from './components/EmblemContainer';
import { setType, setTeamLongread } from '../../reducers/ViewTypeSlice';
import { ButtonsBox, DropdownListItemTeamEdit, LGButtonsWrapper, MobileTabsBox, SettingsDotsWrapper, Tooltip, MinimalTitleName, ButtonWrapper, MobileTabsContainer } from './styles';
import { TeamLgView } from '../teams/components/TeamLgView';
import { LoaderSpinner } from "../../modals/artzLegalsModal/LoaderAnimation";
import useScreenOffset from "../../hooks/useScreenOffset";
import { ProjectsGridActions, ProjectsGridSelector } from "../../reducers/ProjectsGridSlice";
import { isTeamChannel, ModerationType } from "../teams/const/ModerationTypes";
import { NearLessonBlock } from "../../components/NearLessonBlock/NearLessonBlock";
import { getCookie, setCookie } from "../../helpers/cookies";
import { TEAM_SUBSCRIBE_STATUS_SEEN } from "../../modals/TeamSubscribe/const";
import { useGetLMSDisciplines } from "../../hooks/api/LMS/useGetLMSDisciplines";
import GridTitle from "../teams/components/GridTitle";
import { InteractiveEmblem } from "../../components/InteractiveEmblem/InteractiveEmblem";
import { NeutralLinkBasic } from "../../components/link/styles";
import { TeamBottomInfo } from 'shared/components/TeamBottomInfo/TeamBottomInfo';
import { TopLinksList } from "./components/TopLinksList";
import MetaTags from "../../components/MetaTags";
import { useProject } from 'shared/hooks/api/useProject';
import { SettingsDotsIcon } from 'shared/icons/SettingsDotsIcon';
import { COUNTRY_CODES } from "../../../_geograffee/dafes/pages/CountryShowcase";
import { ChannelDefault } from './components/ChannelDefault';

import {
  CONTEXTS_WHERE_BTNS_HIDDEN,
  DARK_THEME,
  CONTEXT_WHERE_CANNOT_CREATE_PROJECT,
  SUBSCRIPTION_CONTEXTS,
} from './const/misc';
import TeamButtons from './components/TeamButtons';
import LongreadButtons from './components/LongreadButtons';
import TeamTitle from './components/TeamTitle';
import TeamLargeTabs from './components/TeamLargeTabs';
import useTeamTabs from './hooks/useTeamTabs';
import { NotFoundChannel, TeamEditFrameDeletedTeam, TeamEditFrameDraftTeam } from 'shared/components/error-frames';
import TeamDescription from './components/TeamDescription';
import TeamTabs from './components/TeamTabs';
import { useGetDisciplinesTabsFromDisciplines } from 'shared/helpers/LMS/getDisciplinesTabsFromDisciplines';
import TeamEmployeesLink from './components/TeamEmployeesLink';
import getNextItemInArray from "shared/utils/getNextItemInArray";
import { TeamStatusActiveArchived, TeamStatusDeleted, TeamStatusDrafts } from 'shared/helpers/teamsStatus';
import { ChannelsInfo } from 'shared/components/ChannelsInfo/ChannelsInfo';
import { getLowercaseTabs } from './support/getLowercaseTabs';
import { TeamLikesController } from './components/TeamLikesController';
import TeamFeed from '../TeamFeed/TeamFeed';
import { ChannelNavigator } from './components/ChannelNavigator';
import { isContext } from 'vm';
import { ShowCaseViewType } from '../teams/const/showcase';
import useAppTester from 'shared/MobileMenu/hooks/useAppTester';
import { CustomBgWrapper } from 'shared/components/CustomBgWrapper/CustomBgWrapper';

export type TOwnerRights = {
  canMake: boolean;
  teamId: string;
}

const BodyOverflowStyle = createGlobalStyle`
  body {
    overflow-y: scroll !important;t
  }
`

export const ExploreHseContextsNew: FC<{ team: any }> = ({ team }) => {
  const isLMSCourse = team?.moderationType === ModerationType.LMS;
  const { disciplinesRaw, loading: disciplinesLoading } = useGetLMSDisciplines(team?.teamId, !isLMSCourse);
  const isMainPage = !!useRouteMatch(['/'])?.isExact;
  const isMediaMain = isMainPage && AppTester.isContext('mediiia');

  const disciplinesTabs = useGetDisciplinesTabsFromDisciplines(disciplinesRaw)

  const teamWithDisciplines = useMemo(() => ({
    ...team,
    tabs: isLMSCourse ? disciplinesTabs : team?.tabs,
  }), [team, disciplinesTabs])

  const getInitialSorting = useMemo(() => {
    if (isMediaMain) {
      return 1;
    }
    if (AppTester.isMonaLisaTravels()) {
      return 1;
    }
    if (window.location.pathname.startsWith('/teams/') || window.location.pathname.startsWith('/special')) {
      const entityType = team?.mainEntityType;
      if (entityType === 'organizations' || entityType === undefined) {
        return 3;
      } else {
        return 1;
      }
    }
    return undefined;
  }, [team?.mainEntityType]);

  if (disciplinesLoading) {
    return null;
  }

  return <EncodedStateFilter initialSorting={getInitialSorting}>
    <ExploreViewContextsInner team={teamWithDisciplines} />
  </EncodedStateFilter>
};


const ExploreViewContextsInner: FC<{ team: any }> = ({ team }) => {
  const {
    sorting,
    display,
    setDisplay,
    setSorting,
  } = useEncodedStateFilter();

  const {
    isAdcrDafesNet,
    isDeziiign,
    isDeziiignMain,
    isDeziiignContext,
    isDvaDesign,
    isHSEDesign,
    isExamHSE: isExam,
    isIqMediiia: isIqMedia,
    isGeograffee,
    isLectureMediiia: isLectureMedia,
    isGalllleryArt,
    isGeoDafes: isDafes,
    isLMSHSE,
    isSuperPuper,
    isMediiia,
    isProDeziiign: isPro,
    isBooksGallllery: isGalllleryBooks,
    isHseSpace,
    isOnlines,
    isCGRAVE,
    isAcademy,
    isKiiidsArt,
  } = useAppTester();

  const isMain = !!useRouteMatch(['/'])?.isExact;
  const isForcedLanding = !!useRouteMatch(['/brnd', '/teams/:teamName/brnd'])?.isExact
  const isDafesCouncilPage = team?.contextName === 'dafes-council';
  const isMainPage = isMain || isForcedLanding;
  const isDafesMain = isDafes && isMainPage;
  const isTeams = !!useRouteMatch(['/teams/:teamName', '/teams/:teamName/brnd'])
  const isRussianGalllleryRoute = !!useRouteMatch('/teams/russiangallllery')

  const isRussianGallllery = AppTester.isBooksGallllery() && isRussianGalllleryRoute

  const {
    about,
    aboutExtra,
    contextName: context,
    name: mainTitle,
    categories,
    isShowTeachersCheckbox: isShowTeachersCheckboxProp,
    isShowEmployeesLink: contextHasEmployees,
    titleImages,
    ownersIDs,
    teamId,
    isShowLongread,
    isShowGridFirst: isShowGrid,
    mainFilter: mainFilterRaw,
    moderationType,
    mainEntityType,
    status: teamStatus,
    isLongreadDisabled,
    isLinksInsteadTitle,
    topLinks,
    isMinimalName,
    isSortingHidden,
    disciplinesRaw = [],
    isSecondaryTitleHidden
  } = team;

  //todo убрать в одно поле
  const initialView = useMemo(() => {
    if (isShowGrid) {
      return ShowCaseViewType.showcase;
    }
    return ShowCaseViewType.landing;
  }, [isShowLongread, isShowGrid]);

  const isShowGridFirst = initialView === ShowCaseViewType.showcase;

  const location = useLocation();

  const isCompetitions = location.pathname.startsWith(LinkTo.awards);

  const isCountryPage = !!useRouteMatch(LinkTo.country);
  const { id: countryId } = useParams<{ id: string }>();

  //todo вынести в админку
  const mainFilter = useMemo(() => {
    if (isCountryPage) {
      return {
        ...mainFilterRaw,
        countryCode: COUNTRY_CODES[countryId as keyof {}],
      }
    }
    if (isCompetitions) {
      return {
        ...mainFilterRaw,
        competitionStatus: Number(sorting) === 1 ? [1, 4, 3] : [5, 6]
      }
    }
    return mainFilterRaw;
  }, [team, isCountryPage, sorting])

  const hasCategories = !!categories?.length;
  const isTeamRoute = !!useRouteMatch('/teams/:id');

  const { t, i18n, i18n: { language } } = useTranslation();

  const theme = useTheme();
  const isMobile = useIsMobile();
  const is992 = useBreakpoint(992);
  const isTab = useBreakpoint(LayoutConst.screen.l)
  const offset = useScreenOffset();
  const history = useHistory();
  const modal = useModal();
  const profile = useProfile();
  const dispatch = useDispatch();
  const isHseDesignMain = AppTester.isContext('hsedesign');
  const projectsWrapperRef = useRef<HTMLDivElement>(null);

  const isMedia = isMediiia && !isLectureMedia;
  const isDesign = isDeziiign && !isHSEDesign;
  const isVisualResearch = useMemo(() => (context === 'hsevisualresearch'), [context])
  const isManagement = useMemo(() => (context === 'hsemanagement' || context === 'hsestartup'), [context])
  const isAgeytomesh = useMemo(() => (context === 'ageytomesh'), [context])
  const isBooks = AppTester.isBooks() && !AppTester.isBooksMediiia();
  const BookDesign = useMemo(() => (context === 'books_deziiign'), [context])
  const isDarkTheme = useMemo(() => ((!isAgeytomesh && !isHSEDesign && !isDesign && !isDafes) || DARK_THEME.includes(context)) && !BookDesign, [BookDesign, isHSEDesign, context])

  const isCreativeCityUnit = useMemo(() => context === 'creativecityacademy', [context])
  const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile]);
  const isGalleryUnit = teamId === '6b5ada7f08524b33be157c4912b2b60d';
  const isLMSOfline = !!useRouteMatch('/courses_offline');
  const [time, setTime] = useState(Date.now());
  const [isFeed, setIsFeed] = useState(false);

  const { isChannel, channelType } = isTeamChannel(moderationType);

  const {
    tabList,
    titleIsTabs,
    currentCategory,
    currentTab,
    tabs,
    tabsRaw,
    tabColors,
    contextTabs,
    categoryList,
    tabIndex,
    setCurrentTab
  } = useTeamTabs(team)

  const owner = useMemo(
    () => (profile && team && team?.owners?.find(
      (owner: Designer<'Global'>) => owner?.accountId === profile?.accountId) || undefined)
    , [team, isChannel]) as Designer | undefined

  const isChannelParticipant = useMemo(() => {
    if ([ModerationType.ChannelGroupOrCourse, ModerationType.Channel]?.includes(moderationType)) {
      return (ownersIDs?.includes(profile?.accountId) || team?.channelCommentWhiteListIds?.includes(profile?.accountId) || team?.membersIDs?.includes(profile?.accountId))
    }
    return true;
  }, [isChannel, profile, isModer, moderationType])

  const [{ isEmpty, onlyAuthor: channelOnlyAuthorsFilter }, setQueryParams] = useQueryState();

  const isTeamPreview = !!useRouteMatch([LinkTo.previewTeam]);
  const isSpecialProjectsPage = !!useRouteMatch([LinkTo.specialProjects]);
  const isSpecialProjects = isSpecialProjectsPage

  const isIqMain = isMain && isIqMedia;

  const { name: currentModalName } = useSelector(modalControllerSelector);
  const modalIsOpen = useMemo(() => currentModalName !== "", [currentModalName]);

  const [coverPost, setCoverPost] = useState<any>(undefined);
  const [isPostLoaded, setIsPostLoaded] = useState<any>(false);
  const [teamByDate, setTeamByDate] = useState<any>(undefined);

  const visibleLG = useSelector((state: any) => state.vt.longreadVisible);
  const teamHasLongread = (!!team?.longread || !!team?.longreadEntityLink?.length) && !isLongreadDisabled;
  const isLandingPage = teamHasLongread && ((isShowGridFirst && isForcedLanding) || (!isShowGridFirst && !isForcedLanding));
  const shouldDisplayLongread = useMemo(() => (isLandingPage && !isTeamPreview && visibleLG), [visibleLG, isLandingPage, isTeamPreview]);

  const isShowTeachersCheckbox = isChannel || isShowTeachersCheckboxProp

  const isMainPageTeam = (isDvaDesign || isAgeytomesh || isCreativeCityUnit) && isMain;

  const isLMSTeam = useMemo(() => moderationType === ModerationType.LMS, [moderationType])

  const isSuperpuperTeam = context === "superpupergames-mediiia";
  const lowercasedCategoryList = getLowercaseTabs(categoryList)
  const lowercasedTabList = getLowercaseTabs(tabList)
  const currentCategoryList = isSuperpuperTeam ? lowercasedCategoryList : categoryList
  const currentTabList = isSuperpuperTeam ? lowercasedTabList : tabList

  const [teamPageLink, brndLink] = useMemo(() => {
    const basePath = isMainPageTeam ? '' : `/teams/${context || teamId}`
    return [`${basePath}`, `${basePath}/brnd`];
  }, [isLMSTeam, isMainPageTeam, context, teamId])

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isLMSTeam && tabs) {
      setIsLoading(true)
    }
    const timer = setTimeout(() => {
      setIsLoading(false);
    });

    return () => clearTimeout(timer);
  }, [])

  useEffect(() => {
    if (team?.isShowFeed && channelType === ModerationType.Channel) {
      setIsFeed(true);
    }
  }, [team?.isShowFeed, channelType])

  const prevTeam = useSelector(ProjectsGridSelector)?.prevTeam;
  const tabsLoading = useSelector(ProjectsGridSelector)?.tabsLoading;
  const preloadedTabs = useSelector(ProjectsGridSelector)?.tabs;

  const entityType = useMemo(() => {
    const categoryEntityType = categories?.length && categories.find(({ path }: any) => path === currentCategory)?.entityType;
    const tabEntityType = tabs?.length && tabs.find(({
      path,
      category
    }: any) => path === currentTab && (!categories?.length || category === currentCategory))?.entityType;
    return tabEntityType || categoryEntityType || team.mainEntityType;
  }, [team, currentCategory, currentTab, tabs])

  const isLMSRequest = useMemo(() => {
    const tab = tabs.find(({ path }: any) => path === currentTab);
    return mainFilter?.moderationTypes?.includes(3) || tab?.filter?.moderationTypes?.includes(3);
  }, [currentTab])

  const isTeamsEntityType = useMemo(() => entityType === 'organizations' || entityType === undefined, [entityType, isHSEDesign])
  const isModulesEntityType = useMemo(() => entityType === "modules", [entityType]);

  //@ts-ignore
  const isOutsideTextPosition = useMemo(() => (coverPost && coverPost?.titlePosition), [coverPost]);

  const isContextWithoutTabs = !tabs.length || (titleIsTabs && !hasCategories);

  const currentTeam = useGetCurrentTeam();
  const customBGHseSpace = isHseSpace;
  const isTimeLine = context === 'timeline'

  const is430 = useBreakpoint(470);
  const is833 = useBreakpoint(833);
  const is744 = useBreakpoint(LayoutConst.screen.s);
  const is743 = useBreakpoint(LayoutConst.screen.s - 1);

  useEffect(() => {
    if (SUBSCRIPTION_CONTEXTS.includes(team?.contextName) && getCookie(TEAM_SUBSCRIBE_STATUS_SEEN + team?.contextName) !== 'true') {
      modal.show('teamSubscribe', {
        teamName: team?.name, teamContext: team?.contextName, onCustomClose: () => {
          setCookie(TEAM_SUBSCRIBE_STATUS_SEEN + team?.contextName, 'true');
          modal.hide()
        }
      })
    }
  }, [team?.contextName, team?.name])

  const canMakeImageForTeam: TOwnerRights = useMemo(() => profile && team?.ownersIDs?.includes(profile?.accountId) && {
    canMake: team?.ownersIDs?.includes(profile?.accountId),
    teamId: team?.teamId
  }, [team, profile]);

  const vtype = useMemo(() => (team?.longread?.viewType || 't-shape'), [team]);

  const isReplaceLongread = !!team?.longreadType

  const activeTab = useMemo(() => {
    return team?.tabs?.find((tab: any) => tab.path === currentTab)
  }, [currentTab, team])

  const [description, descriptionExtra, tabTitle, tabLinks, isLinksShow] = useMemo(() => {
    const selectedTab = (!!categories?.length && currentCategory)
      ? categories?.find(({ path }: any) => path === currentCategory)
      : currentTab && tabs?.find(({ path }: any) => path === currentTab);

    const showTeamByDateAbout = activeTab?.filter?.useCalendar && !!teamByDate?.about?.length
    const showTeamByDateLinks = !showTeamByDateAbout && activeTab?.filter?.useCalendar && !!teamByDate?.topLinks?.length

    const teamDescription = team?.onlyMainDescription ? team?.about
      : showTeamByDateAbout && teamByDate?.about || (!!selectedTab?.about?.length && selectedTab?.about) || about;
    const teamLinks = showTeamByDateLinks ? (teamByDate?.topLinks || []) : selectedTab?.topLinks || [];
    const showteamLinks = showTeamByDateLinks ? true : (selectedTab?.isLinksShow ?? false)

    return [
      teamDescription, // description
      (!!selectedTab?.aboutExtra?.length && selectedTab?.aboutExtra) || aboutExtra, // description
      selectedTab?.name || '', // tabTitle
      teamLinks, // tabLinks
      showteamLinks, // isLinksShow

    ];
  }, [tabs, about, currentTab, currentCategory, categories, teamByDate, language, activeTab]);

  const showLinks = useMemo(() => {
    return isLinksInsteadTitle || isLinksShow
  }, [isLinksInsteadTitle, isLinksShow])

  const isFinalyShowLinks = useMemo(() => !showLinks, [showLinks]);

  const computeLinks = useMemo(() => {
    if (isLinksInsteadTitle) {
      return topLinks
    } else {
      return tabLinks
    }
  }, [showLinks, topLinks, tabLinks])

  const gridTitleBlock = useMemo(() => {
    const tab = tabs.find(({ path }: any) => path === currentTab);
    if (tab?.gridTitle?.length) {
      if (tab?.gridTitleLink?.length) {
        return (
          <NeutralLinkBasic href={tab.gridTitleLink} target="_blank">
            <GridTitle title={tab.gridTitle} />
          </NeutralLinkBasic>
        )
      }
      return <GridTitle title={tab.gridTitle} />
    }
    return null;
  }, [currentTab, language])

  const [extraFilter, onExtraFilterChange] = useExtraFilter(!isShowTeachersCheckbox);

  const replacedGlobalTypeFilter = useMemo(
    () => (extraFilter.globalType?.includes('student') ? {} : extraFilter), [extraFilter]);

  const serialzeTab = useMemo(() => {
    return isContextWithoutTabs && (!titleIsTabs || hasCategories) ? 'all' : currentTab
  }, [currentTab, titleIsTabs, isContextWithoutTabs])

  const tabLoading = tabsLoading?.[currentCategory]?.[serialzeTab];

  const ParamWithoutContext = useMemo(() => !mainFilter?.contexts?.length, [team]);

  const isLMSCourse = team?.contexts && team?.moderationType === ModerationType.LMS

  const onChannelOnlyAuthorsFilterChange = (value: boolean) => {
    setQueryParams({ onlyAuthor: value }, { replace: true })
  }

  const hasTeamsInitialSorting = useMemo(() => {
    return isTeamsEntityType && !isLMSRequest
  }, [isTeamsEntityType, isLMSHSE])

  const defaultProjectStatus = useMemo(() => {
    if (isExam) {
      return [1, 10];
    }
    return [1];
  }, [])

  const projectsButchFilter = useMemo(() => {
    const baseFilter = {
      ...(!isCompetitions && {
        projectFilter: hasTeamsInitialSorting ? 3 : convertSorting(sorting, {
          isHSEDesign,
          isOnlines,
          isSuperPuper,
          isAgeytomesh,
          isDeziiign,
          isPro,
          isTeam: teamId,
          isLMSRequest,
          isLMSOfline
        })
      }),
      isLite: true,
      limit: offset,
      ...mainFilter,
      projectStatus: mainFilter?.projectStatus?.length ? mainFilter.projectStatus : defaultProjectStatus,
      ...replacedGlobalTypeFilter,
      requestContext: context,
      sort: sorting,
      ...(isExam && {
        globalTypes: [],
      }),
    };



    baseFilter.hasProductCards = Number(sorting) === Number(SortingTypeIndex.shop);

    return baseFilter;
  }, [
    sorting,
    currentTeam,
    replacedGlobalTypeFilter,
    isAgeytomesh,
    isVisualResearch,
    isSuperPuper,
    isManagement,
    ParamWithoutContext,
    convertSorting,
    isHSEDesign,
    isOnlines,
    isDeziiign,
    context,
    mainFilter,
    isLMSHSE,
    currentTab,
    isTeamsEntityType,
    isCompetitions
  ]);

  useEffect(() => {
    if (isChannel ? (prevTeam !== teamId) : (prevTeam !== context)) {
      // if (!disciplinesLoading) {
      dispatch(ProjectsGridActions.setTabs({
        tabs: tabsRaw,
        categories,
        mainEntityType,
        mainFilter,
        context,
      }))
      // }
    }
  }, [context, teamId, prevTeam, tabsRaw, isChannel])

  useEffect(() => {
    if (isLandingPage) {
      setVisibleLG(isLandingPage)
    }
  }, [context, isLandingPage])

  useEffect(() => {
    if (team?.membersIDs?.includes(profile?.accountId) || team?.ownersIDs?.includes(profile?.accountId)) {
      setVisibleLG(false)
    }
  }, [])



  const shouldHideTabs = useMemo(
    () => isTimeLine || isEmpty || (isMedia && isBooks)
    , [context, isEmpty, isSpecialProjects, isMedia, isTimeLine, isBooks, is430]);

  const shouldVisibleMobileTabs = useMemo(() => {
    return ((((isMedia && !isSpecialProjects) || isLectureMedia) && isTab && !isEmpty) || (!isContextWithoutTabs && !titleIsTabs && isTab))
  }, [
    isTab, isSpecialProjects, isContextWithoutTabs, isEmpty, isMobile, titleIsTabs]);
  const shouldVisibleMobileTabsOrTeamLink = useMemo(() => (!shouldHideTabs && (shouldVisibleMobileTabs || (contextHasEmployees && isMobile))), [contextHasEmployees, shouldVisibleMobileTabs, isMobile, shouldHideTabs]);

  useEffect(() => {
    if (teamHasLongread && vtype) {
      dispatch(setType(vtype))
    }
  }, [teamHasLongread, dispatch, vtype])

  const setVisibleLG = (value: boolean) => {
    dispatch(setTeamLongread(value))
  }

  useEffect(() => {
    if (team && teamHasLongread) {
      API.request()
        .endpoint(Endpoints.longread)
        .url('api/post/GetMany')
        .addQuery('idUser', '2')
        //@ts-ignore
        .addQuery('idLongread', isReplaceLongread ? team?.replaceLongreadId : team?.longreadId)
        .get()
        .send()
        .then((r) => r.json())
        .then((r) => {
          setCoverPost(r?.filter((i: any) => i?.style === 'as_cover')[0])
          setIsPostLoaded(true)
        })
    }
  }, [teamHasLongread, team?.replaceLongreadId, team?.longreadId, isReplaceLongread])

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
  }, [setSorting]);

  const showShop = isGalllleryArt || isDeziiignMain || isHSEDesign || isAcademy || isMediiia || isDafes || isKiiidsArt;

  const sortingMethods = useMemo(() => {
    const shopMethod = showShop ? [30] : [];

    if (isCompetitions) {
      return [1, 2]
    }
    if (isVisualResearch) {
      return [1, 2, 13, 20]
    }
    if (isLMSRequest) {
      return [1, 10, 9]
    }
    if (isLMSOfline) {
      return [10, 9, 3, 0]
    }
    if (isTeamsEntityType) {
      // Показываем сортировки медиа каналов только на табе edu-channels
      return [3, 4, 5];
    }
    if (isDeziiignContext) {
      return [1, 2, 26, ...shopMethod];
    }
    return [1, 2, 26, 20, ...shopMethod];
  }, [isLMSRequest, isVisualResearch, isHSEDesign, showShop, isTeamsEntityType, isMedia])

  // useEffect(() => {
  //   const storedSorting = localStorage.getItem('brg_sorting');
  //   if (storedSorting === String(SortingTypeIndex.shop) && !showShop) {
  //     localStorage.removeItem('brg_sorting');
  //     setSorting(SortingTypeIndex.relevant);
  //   }
  // }, [showShop, setSorting]);

  const prevIsTeamsEntityType = useRef(isTeamsEntityType);
  const prevCurrentTab = useRef(currentTab);
  const prevIsMedia = useRef(isMedia);

  useEffect(() => {
    const isEntityTypeChanged = prevIsTeamsEntityType.current !== isTeamsEntityType;
    const isTabChanged = prevCurrentTab.current !== currentTab;
    const isMediaChanged = prevIsMedia.current !== isMedia;

    if (isEntityTypeChanged) {
      if (isTeamsEntityType) {
        const defaultValue = sortingMethods[0];
        setSorting(defaultValue);
      } else {
        setSorting(SortingTypeIndex.relevant);
      }
      prevIsTeamsEntityType.current = isTeamsEntityType;
    } else if (isTeamsEntityType && (isTabChanged || isMediaChanged)) {
      const defaultValue = sortingMethods[0];
      setSorting(defaultValue);
    } else if (isTeamsEntityType && !sortingMethods.includes(Number(sorting))) {
      const defaultValue = sortingMethods[0];
      setSorting(defaultValue);
    }

    prevCurrentTab.current = currentTab;
    prevIsMedia.current = isMedia;
  }, [isTeamsEntityType, currentTab, isMedia, setSorting, sorting, sortingMethods]);

  const teamLink = useMemo(() => {
    return <TeamEmployeesLink team={team} />
  }, [team])
  const tabsGroup = useMemo(() => {
    return <TeamTabs
      team={team}
      tabList={currentTabList}
      tabColors={tabColors}
      setCurrentTab={setCurrentTab}
      currentTab={currentTab}
      contextTabs={contextTabs}
      tabIndex={tabIndex}
      titleIsTabs={titleIsTabs}
      isLoading={isLMSTeam ? isLoading : false}
      isContextWithoutTabs={isContextWithoutTabs}
    />
  }, [team, tabList, tabColors, setCurrentTab, currentTab, contextTabs, tabIndex, titleIsTabs, isLoading, isContextWithoutTabs])

  const hasTeamEmblem = useMemo(
    () => ((!!team?.titleImages?.length && !!team?.isShowTeamEmblem) || [ModerationType.ChannelGroupOrCourse, ModerationType.Channel]?.includes(channelType))
    , [team, channelType]);

  const activeTabHasImage = !!activeTab?.titleImages?.length;
  const dayTeamHasImage = activeTab?.filter?.useCalendar === true && teamByDate && !!teamByDate?.titleImages?.length

  // получаем организацию по календарю
  const getCurrentDate = () => {
    const now = new Date();
    return {
      day: now.getDate(),
      month: now.getMonth() + 1
    };
  };

  useEffect(() => {

    if (activeTab?.filter?.useCalendar === true) {
      const { day, month } = getCurrentDate();

      API.request()
        .endpoint(Endpoints.geograffee)
        .url('api/Team/GetByDate')
        .addQuery('day', day.toString())
        .addQuery('month', month.toString())
        .get()
        .send()
        .then((r) => r.json())
        .then((data) => {
          console.log('Team by date data:', data);
          setTeamByDate(API.toLang(data, language));
        })
        .catch((error) => {
          console.error('Error fetching team by date:', error);
        });
    }
  }, [activeTab?.filter?.useCalendar, currentTab, language]);

  const shouldDisplayEmblem = useMemo(() => (hasTeamEmblem || activeTabHasImage || dayTeamHasImage || (isDafesMain)), [hasTeamEmblem, activeTabHasImage, isDafesMain, dayTeamHasImage]);

  const onMobileSortingClick = useCallback(() => {
    const nextSorting = getNextItemInArray(Number(sorting), sortingMethods)
    setSorting(nextSorting)
  }, [sorting, setSorting, sortingMethods]);

  const teamButtons = useMemo(() => {
    const showTeamByDateButtons = activeTab?.filter?.useCalendar && !!teamByDate && !!teamByDate?.buttons?.length

    return <TeamButtons team={showTeamByDateButtons ? teamByDate : team} disciplinesRaw={disciplinesRaw} currentTab={currentTab} />;
  }, [team, disciplinesRaw, language, teamByDate, activeTab])

  const btnWrapper = useMemo(() => {

    const isButtons = !((is430 || CONTEXTS_WHERE_BTNS_HIDDEN.includes(context))
      && (!is430 || CONTEXT_WHERE_CANNOT_CREATE_PROJECT.includes(context))
      && CONTEXTS_WHERE_BTNS_HIDDEN.includes(context))

    if (
      (isMobile || isContextWithoutTabs || titleIsTabs)
      && (is430 || CONTEXTS_WHERE_BTNS_HIDDEN.includes(context))
      && (!is430 || CONTEXT_WHERE_CANNOT_CREATE_PROJECT.includes(context))
      && CONTEXTS_WHERE_BTNS_HIDDEN.includes(context) && !isDafesMain
    ) return null;

    if (!teamButtons && !tabsGroup) return null;

    if (isTab && !isDafesMain) return <>{teamButtons}</>

    return (
      <ButtonWrapper
        className='team-button-wrapper'
        hasTabsGroup={!!tabsGroup}
        isButtons={isButtons}
      >
        {teamButtons}
        {!(isDafesMain && is743) && tabsGroup}
      </ButtonWrapper>
    )
  }, [
    tabsGroup,
    isMobile,
    context,
    t,
    i18n.language,
    is430,
    isContextWithoutTabs,
    teamButtons,
    isTab,
    is743,
    isEmpty, titleIsTabs, is833, owner,
    isTeamPreview, profile, isAgeytomesh,
    currentTab, shouldDisplayEmblem,
    isForcedLanding, teamHasLongread]);


  const LgButtons = useMemo(() => {
    if (teamHasLongread) {
      return <LongreadButtons team={team} disciplines={disciplinesRaw} currentTab={currentTab} />
    }
  }, [teamHasLongread, language, currentTab])

  const searchBar = useMemo(
    () => (
      <ProjectsSearchBar
        isLoading={false}
        isCategoriesHidden={true}
        sorting={sorting}
        onSortingChange={onSortingChange}
        sortingMethods={sortingMethods}
        hideLeftBar
        isChannel={isChannel}
        hideRightBar={!isTeamsEntityType}
        hideRightButtons
        extraFilter={isChannel ? channelOnlyAuthorsFilter : extraFilter}
        onExtraFilterChange={isChannel ? onChannelOnlyAuthorsFilterChange : isShowTeachersCheckbox ? onExtraFilterChange : undefined}
        display={flipDisplay(display)}
        onDisplayChange={() => {
          setDisplay(flipDisplay(display));
        }}
        isCompetitions={isCompetitions}
      />
    ),
    [
      display,
      sorting,
      onSortingChange,
      sortingMethods,
      setDisplay,
      extraFilter,
      onExtraFilterChange,
      isShowTeachersCheckbox,
      isMobile,
      ParamWithoutContext,
      isChannel,
      isForcedLanding,
      isTeamsEntityType,
    ],
  );

  const mobileLikeBar = useMemo(() => {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {contextHasEmployees && teamLink}
        {team?.showQu && (
          <FlexBox align='center'>
            <TeamLikesController
              entityId={team?.teamId}
              entityType="team"
            />
          </FlexBox>
        )}
      </div>
    )
  }, [team, contextHasEmployees, teamLink])

  const mobileSortingText = useMemo(() => {
    if (isTeamsEntityType) {
      if (sortingMethods.includes(Number(sorting))) {
        const sortingKey = Number(sorting) === 3 ? 'organizations_created' :
          Number(sorting) === 4 ? 'organizations_popular' :
            Number(sorting) === 5 ? 'organizations_popular_last_period' : '';
        return t(`sorting_type.${sortingKey}`)
      }
      return '';
    }
    return t(`sorting_type.${Number(sorting) === 1 ? 'latest' : Number(sorting) === 10 ? 'price_inc' : Number(sorting) === 9 ? 'price_dec' :
      Number(sorting) === 2 ? 'rating' : Number(sorting) === 26 ? 'popular' : Number(sorting) === 20 ? 'relevant' : Number(sorting) === 30 ? 'shop' : 'score'}`)
  }, [sorting, currentTab, isTeamsEntityType, sortingMethods, t])

  const MobileSearchBar = useMemo(
    () => (
      <MobileFilterRow
        style={{
          justifyContent: isMinimalName && !shouldVisibleMobileTabsOrTeamLink ? 'space-between' : 'flex-end',
          flexDirection: is743 && isMinimalName && !shouldVisibleMobileTabsOrTeamLink ? 'column' : 'row',
          alignItems: is743 && isMinimalName && !shouldVisibleMobileTabsOrTeamLink && 'flex-end',
          width: '100%'
        }}
      >
        {isMinimalName && !shouldVisibleMobileTabsOrTeamLink && <MinimalTitleName>{mainTitle}</MinimalTitleName>}
        <FlexBox>
          {!isMobile && !isTab && !shouldVisibleMobileTabs && contextHasEmployees && teamLink}
          {((isTab) && !(isLMSCourse || isLMSHSE)) ? (
            <>
              {!team?.showQu && is743 && contextHasEmployees && teamLink}
              {!is743 && (
                <>
                  {mobileLikeBar}
                  {team?.showQu && <span style={{ margin: '0 16px', color: '#909090' }}>|</span>}
                </>
              )}
              {!isModulesEntityType && <MobileFilterSort isLectureMedia={isLectureMedia} onClick={onMobileSortingClick}>
                <SortIcon />
                {mobileSortingText}
              </MobileFilterSort>}
            </>
          ) : (
            !(isLMSCourse || isLMSHSE) && <ProjectSearchBarSorting
              selectedSorting={sorting ?? 1}
              onSortingChange={onSortingChange}
              sortingMethods={sortingMethods}
              isCompetitions={isCompetitions}
            />
          )}
        </FlexBox>

      </MobileFilterRow>
    ), [isMobile, modal, isTab, mobileSortingText, context, onMobileSortingClick, sorting, onSortingChange, shouldVisibleMobileTabsOrTeamLink, isModulesEntityType, isLectureMedia, team?.showQu, is743, contextHasEmployees, teamLink, mobileLikeBar, isLMSCourse, isLMSHSE, sortingMethods, isCompetitions, isMinimalName, mainTitle])

  const sortBar = useMemo(
    () => {
      if (isSortingHidden || shouldHideTabs || isDafesCouncilPage || isLMSOfline) return null;

      return (
        <SearchBarBox justifyMobile={isMinimalName ? 'space-between' : 'flex-end'} direction='row'>
          {isTab ? MobileSearchBar : (
            <FlexBox className={'search-box'}>
              {contextHasEmployees && teamLink}
              {team?.showQu && (
                <FlexBox align='center'>
                  <TeamLikesController
                    entityId={team?.teamId}
                    entityType="team"
                  />
                  {!isModulesEntityType && <span style={{ margin: '0 16px', color: '#909090' }}>|</span>}
                </FlexBox>
              )}
              {isTeamsEntityType ? (
                <OrganizationsSorting
                  selectedSorting={sorting}
                  onSortingChange={onSortingChange}
                  sortingMethods={sortingMethods}
                  isDarkTheme={isDarkTheme}
                  isCompetitions={isCompetitions}
                />
              ) : isModulesEntityType ? null : (
                <ProjectSearchBarSorting
                  selectedSorting={sorting}
                  onSortingChange={onSortingChange}
                  sortingMethods={sortingMethods}
                  isDarkTheme={isDarkTheme}
                  isCompetitions={isCompetitions}
                />
              )
              }
            </FlexBox>
          )}
        </SearchBarBox>
      )

    }, [
    isMobile,
    MobileSearchBar,
    isDafesMain,
    contextHasEmployees,
    isMedia,
    currentTab,
    isDafesCouncilPage,
    isTab,
    sorting,
    onSortingChange,
    isVisualResearch,
    shouldHideTabs,
    currentCategory,
    team,
    isLMSOfline,
    isModulesEntityType]
  );


  const canEditTeamEmblem = useMemo(() => {
    if (TeamStatusActiveArchived(team)) return false

    return (!!owner && hasTeamEmblem);
  }, [owner, hasTeamEmblem]);

  const titleClickableProps = useMemo(
    () => (
      teamHasLongread ? {
        isCliclable: true, onClick: () => {
          history.push(isShowGridFirst ? brndLink : teamPageLink);
          setVisibleLG(!visibleLG);
        }
      } : {}), [teamHasLongread, brndLink, teamPageLink, visibleLG])


  const teacherCheckbox = useMemo(() => {
    return (
      <FlexBox
        className={'teacher-checkbox'}
        style={{
          justifyContent: 'flexStart',
          marginBottom: is744 ? 0 : isTab ? 26 : 0,
          width: isTab ? '100%' : 'auto',
          ...(is744 ? { order: 1 } : {}),
          ...(isTab ? { alignItems: 'flex-end' } : {}),
          ...(shouldDisplayEmblem ? { marginTop: isTab ? 0 : 10 } :
            { marginTop: is744 ? 0 : isTab ? 18 : 10, }
          )
        }}
      >
        {searchBar}
      </FlexBox>
    )
  }, [searchBar, isTab, is744])

  const renderButtonsBlock = isDafesMain && isTab ? null : btnWrapper && shouldDisplayEmblem && ((!isShowTeachersCheckbox && !isTab) || !is743)

  const shouldDisplayButtonsBox = useMemo(() => {
    return !(shouldDisplayEmblem && isTab && !is743) || (!btnWrapper && !isShowTeachersCheckbox && (isGalleryUnit || context === 'amschoolportfolio' || is743))
  }, [shouldDisplayEmblem, isTab, is743, btnWrapper, isShowTeachersCheckbox, isGalleryUnit, context])

  const [projectSource, isProjectLoading, projectError] = useProject(team?.replaceLongreadId, i18n.language, team?.replaceLongreadId + time);

  const handleTeamEdit = () => history.push(CreateLinkTo.teamEdit(teamId ?? "undefined"));

  const titleGroup = useMemo(() => {
    return <TeamTitle
      team={team}
      onClick={titleClickableProps}
      tabList={tabList}
      currentTab={currentTab}
    />;
  }, [isChannel, currentTab, tabList, titleClickableProps, team])

  if (shouldDisplayLongread && !coverPost && !isPostLoaded) {
    return <LoaderSpinner />
  }

  if (isChannel && TeamStatusDeleted(team)) {
    return (
      <TeamEditFrameDeletedTeam id={team?.owners?.[0]?.designerId} />
    )
  }

  if (isChannel && TeamStatusDrafts(team)) {
    return (
      <TeamEditFrameDraftTeam
        owner={owner}
        teamId={team?.teamId}
      />
    )
  }

  // if (!isNotAGroupChannelParticipant) {
  //   return (
  //     <NotFoundChannel id={''} />
  //   )
  // }

  if (isChannel && isFeed) {
    return (
      <CoreContainer>
        <ChannelsInfo
          team={team}
          onToggle={setIsFeed}
          isFeed={isFeed}
        />
        {titleGroup}
        {<TeamFeed team={team} />}
      </CoreContainer>
    )
  }

  if (shouldDisplayLongread && !!coverPost && !!isOutsideTextPosition) {
    return (
      <TeamLgView
        teamTags={team?.tags}
        managedTags={team?.managedTags}
        team={team}
        //@ts-ignore
        color={isReplaceLongread ? projectSource?.additionalInfo?.color : team?.additionalInfo?.color}
        //@ts-ignore
        additionalContent={isReplaceLongread ? projectSource?.additionalContent : team?.additionalContent}
        isModer={true}
        buttons={LgButtons}
        title={coverPost}
        titleVisible={isOutsideTextPosition === 'outside'}
        projectSource={projectSource}
      />
    )
  }

  return (
    <CustomBgWrapper backgroundColor={isRussianGallllery? '#E7E7E7' : ''}>
      <CoreContainer
        isCGRAVE={isCGRAVE}
        minOffset={isIqMain || isCGRAVE}
      >
        {isTeams && (
          <MetaTags
            title={`${isMedia ? 'Mediiia | ' : ''}${mainTitle}`}
            description={[description]}
            images={titleImages}
          />
        )}
        {!modalIsOpen && <BodyOverflowStyle />}
        {(isMedia || isLectureMedia || customBGHseSpace || isGalllleryArt) && <GlobalChangeColorWrapper />}
        <FlexBox direction="column" directionMobile="column" flex="1">
          <div style={{ position: 'relative' }}>
            {showLinks && (
              <FlexBox direction={shouldDisplayEmblem ? 'row' : 'column'} directionMobile={'row'}
                  justify={shouldDisplayEmblem ? 'space-between' : 'flex-start'}>
                <TopLinksList topLinks={computeLinks} />
                {shouldDisplayEmblem && !is743 && (
                        <>
                          {!isDafesMain ? (
                            <EmblemContainer
                              team={activeTab?.filter?.useCalendar === true && teamByDate || team}
                              owner={owner}
                              canEditEmblem={canEditTeamEmblem}
                              currentTab={currentTab}
                            />
                          ) : (<InteractiveEmblem currentTab={currentTab} />)}
                        </>
                  )}
              </FlexBox>)}
            {isChannel && <ChannelsInfo team={team} onToggle={setIsFeed} />}
            {isFinalyShowLinks && (
              <>
                <FlexBox direction={shouldDisplayEmblem ? 'row' : 'column'} directionMobile={'row'}
                  justify={shouldDisplayEmblem ? 'space-between' : 'flex-start'}>
                  <FlexBox direction={'column'} directionMobile='column' width={'100%'}>
                    <TeamLargeTabs
                      team={team}
                      currentCategory={currentCategory}
                      currentTab={currentTab}
                      categoryList={currentCategoryList}
                      tabList={tabList}
                      tabsRaw={tabs}
                    />
                    {titleGroup}
                    <ChannelNavigator channel={team} />
                    <BottomGroupWrapper
                      className='explore-view_bottom-group-wrapper'
                      justifyBetween={shouldDisplayEmblem && !is833}
                      titleIsTabs={titleIsTabs}
                      disableOffset={(isDesign || isGeograffee) && is430 && !isAgeytomesh}
                      disabledTabs={shouldDisplayEmblem}
                      disableButtons={isShowTeachersCheckbox}
                      hasEmblem={shouldDisplayEmblem}
                      isMedia={isMedia}
                      teamButtons={!!teamButtons}
                    >
                      <TeamDescription team={team} description={description} fillButtonsSpace={!renderButtonsBlock} />
                      {renderButtonsBlock && btnWrapper}
                    </BottomGroupWrapper>

                  </FlexBox>
                  {shouldDisplayEmblem && !is743 && (
                    <>
                      {!isDafesMain ? (
                        <EmblemContainer
                          team={activeTab?.filter?.useCalendar === true && teamByDate || team}
                          owner={owner}
                          canEditEmblem={canEditTeamEmblem}
                          currentTab={currentTab}
                        />
                      ) : (<InteractiveEmblem currentTab={currentTab} />)}
                    </>
                  )}
                </FlexBox>
              </>
            )}

            {(isModer || !!owner) && isTeams && !isChannel && !isMinimalName && <SettingsDotsWrapper shouldDisplayEmblem={shouldDisplayEmblem && !is743}>
              <Dropdown
                offsetY={8}
                offsetX={0}
                hideArrow
                orientation='right'
                target={
                  <SettingsDotsIcon />
                }
              >
                <DropdownListItemTeamEdit theming={theme.navigationBar.login} onClick={handleTeamEdit}>{t('edit-organization')}</DropdownListItemTeamEdit>
              </Dropdown>
            </SettingsDotsWrapper>}

          </div>

          {isLMSTeam && <NearLessonBlock teamId={teamId} />}
          <BottomOuterContainer
            className='explore-view_bottom-outer-container'
            directionMobile={'column'}
            direction={'column'}
            {...(isHseDesignMain && isTab && { direction: 'column' })}
            justify="space-between"
            align={'flex-end'}
            disabledOffset={isMinimalName}
            disabledTabs={(shouldDisplayEmblem && !isShowTeachersCheckbox && !showLinks) || isEmpty}
            disableGap={shouldDisplayEmblem || !isShowTeachersCheckbox || isMinimalName}
            isLMSTeam={isLMSTeam}
            isChannel={isChannel}
            visibleMobileTabs={shouldVisibleMobileTabsOrTeamLink}
            style={{ display: shouldHideTabs ? 'none' : 'flex' }}
            gy={isTab ? 24 : 32}
            isGalllleryBooks={isGalllleryBooks}
            teamButtons={!!teamButtons}
          >
            {isShowTeachersCheckbox && is744 && teacherCheckbox}

            {shouldDisplayButtonsBox && (
              <FlexBox width={'100%'}>
                <ButtonsBox className='explore-view_buttons-box' align={isShowTeachersCheckbox ? 'baseline' : 'center'} >
                  {btnWrapper}
                  {isMinimalName && (!isTab || is743) && <MinimalTitleName>{mainTitle}</MinimalTitleName>}

                  {(isModer || !!owner) && isTeams && !isChannel && isMinimalName && !isMobile && <SettingsDotsWrapper isMinimalName={isMinimalName} shouldDisplayEmblem={shouldDisplayEmblem && !is743}>
                    <Dropdown
                      offsetY={8}
                      offsetX={0}
                      hideArrow
                      orientation='right'
                      target={
                        <SettingsDotsIcon />
                      }
                    >
                      <DropdownListItemTeamEdit theming={theme.navigationBar.login} onClick={handleTeamEdit}>{t('edit-organization')}</DropdownListItemTeamEdit>
                    </Dropdown>
                  </SettingsDotsWrapper>}
                  {
                    (isShowTeachersCheckbox && !is744) ||
                    (!isTab && !isSortingHidden) &&
                    <FlexBox
                    className={isSuperpuperTeam ? '' : 'js-right-side-box'}
                    direction='column'
                    width={isTab ? '100%' : 'auto'}
                    style={{ height: '100%', rowGap: isShowTeachersCheckbox ? 32 : /*70*/ 0 }}
                    justify='space-between'
                    align='flex-end'
                  >
                    {isShowTeachersCheckbox && !is744 ? teacherCheckbox : <div />}
                    {!isTab && !isSortingHidden && sortBar}
                  </FlexBox>
                  }
                </ButtonsBox>
              </FlexBox>)}

            {isTab && !isAdcrDafesNet && (
              <MobileTabsContainer className='explore-view_mobile-tabs-container' hasLikes={is743 && team?.showQu}>
                {isMinimalName && shouldVisibleMobileTabsOrTeamLink && <MinimalTitleName>{mainTitle}</MinimalTitleName>}
                {is743 && team?.showQu && (
                  <div style={{ marginBottom: 24 }}>
                    {mobileLikeBar}
                  </div>
                )}
                <MobileTabsBox>
                  {(shouldDisplayEmblem && !is744) && isShowTeachersCheckbox && teacherCheckbox}
                  <FlexBox
                    widthMobile={'100%'}
                    width={'100%'}
                    justify={isTab ? 'space-between' : 'flex-end'}
                    {...(!isShowTeachersCheckbox && isFinalyShowLinks && { ...(is744 && !is743 && { offsetBottomMobile: 26 }) })}
                  >
                    {isDafesMain && !is743 ? btnWrapper : shouldVisibleMobileTabsOrTeamLink && tabsGroup}
                    {!isSortingHidden && sortBar}
                  </FlexBox>
                </MobileTabsBox>
              </MobileTabsContainer>

            )}
          </BottomOuterContainer>
          {gridTitleBlock}
          {!isEmpty && (
            <ProjectControllerWrapper
              ref={projectsWrapperRef}
              isTeamRoute={isTeamRoute}
            >
              <ProjectsButchController
                filter={projectsButchFilter}
                currentCategory={currentCategory}
                currentTab={serialzeTab}
                contextName={context}
                channelOwnerId={channelOnlyAuthorsFilter ? owner?.accountId : undefined}
                isChannel={isChannel}
                isChannelParticipant={isChannelParticipant}
                teamId={teamId}
                emptyMsgText={isLMSHSE ? t('empty_category_new') : undefined}
                {...isMedia && is743 ? { mobileColumns: 1 } : {}}
                canMakeImageForTeam={canMakeImageForTeam}
                isMainPage
              />
            </ProjectControllerWrapper>
          )}
        </FlexBox>
        {!!descriptionExtra?.length && (
          <DescriptionExtra preLine>
            {descriptionExtra}
          </DescriptionExtra>
        )}
        {!isChannel && !isSecondaryTitleHidden && <TeamBottomInfo
          title={titleGroup}
          buttons={teamButtons}
        />}
      </CoreContainer>
    </CustomBgWrapper>
  );
};

export default ExploreHseContextsNew;
/* eslint-disable react-hooks/rules-of-hooks */
import React, { FC, useEffect, useMemo, useState, useCallback, useRef } from 'react';
import { ProjectsSearchBar } from '../../components/projectsSearchBar/projectsSearchBar';
import { OrganizationsSorting } from '../../components/projectsSearchBar/components/organizationsSorting';
import { useTranslation } from 'react-i18next';
import { FlexBox, useIsMobile, useBreakpoint, Dropdown } from '@brg/ui';
import { API, Designer, Endpoints } from '@brg/api';
import { createGlobalStyle, useTheme } from 'styled-components';
import {
  CoreContainer,
  LayoutConst,
  modalControllerSelector,
  useModal
} from '../../../core';
import { SortingTypeIndex } from '../../constants/sortingType';
import ProjectsButchController from '../../../core/controllers/ProjectsButchControllerUltimate';
import { useEncodedStateFilter, EncodedStateFilter } from '../../components/Filters';
import { flipDisplay } from '../../utils/display'
import useExtraFilter from "../../hooks/useExtraFilter";
import { MobileFilterRow, MobileFilterSort } from '../explore/exploreView';
import { SortIcon } from 'shared/icons';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { CreateLinkTo, LinkTo } from 'shared/constants/linkTo';
import {
  BottomGroupWrapper,
  ProjectControllerWrapper,
  SearchBarBox,
  BottomOuterContainer,
  GlobalChangeColorWrapper,
  DescriptionExtra,
} from '../explore/styles';
import useQueryState from 'shared/hooks/useQueryState';
import { ProjectSearchBarSorting } from '../../components/projectsSearchBar/components/projectSearchBarSorting';
import { useDispatch, useSelector } from 'react-redux';
import { AppTester } from 'supporting';
import { bProfile, useProfile } from '@brg/auth';
import { convertSorting } from "./model/convertSorting";
import { useGetCurrentTeam } from "../../hooks/useGetCurrentTeam";
import { ProjectsGridNew } from "../../components/grids";
import { EmblemContainer } from './components/EmblemContainer';
import { setType, setTeamLongread } from '../../reducers/ViewTypeSlice';
import { ButtonsBox, DropdownListItemTeamEdit, LGButtonsWrapper, MobileTabsBox, SettingsDotsWrapper, Tooltip, MinimalTitleName, ButtonWrapper, MobileTabsContainer } from './styles';
import { TeamLgView } from '../teams/components/TeamLgView';
import { LoaderSpinner } from "../../modals/artzLegalsModal/LoaderAnimation";
import useScreenOffset from "../../hooks/useScreenOffset";
import { ProjectsGridActions, ProjectsGridSelector } from "../../reducers/ProjectsGridSlice";
import { isTeamChannel, ModerationType } from "../teams/const/ModerationTypes";
import { NearLessonBlock } from "../../components/NearLessonBlock/NearLessonBlock";
import { getCookie, setCookie } from "../../helpers/cookies";
import { TEAM_SUBSCRIBE_STATUS_SEEN } from "../../modals/TeamSubscribe/const";
import { useGetLMSDisciplines } from "../../hooks/api/LMS/useGetLMSDisciplines";
import GridTitle from "../teams/components/GridTitle";
import { InteractiveEmblem } from "../../components/InteractiveEmblem/InteractiveEmblem";
import { NeutralLinkBasic } from "../../components/link/styles";
import { TeamBottomInfo } from 'shared/components/TeamBottomInfo/TeamBottomInfo';
import { TopLinksList } from "./components/TopLinksList";
import MetaTags from "../../components/MetaTags";
import { useProject } from 'shared/hooks/api/useProject';
import { SettingsDotsIcon } from 'shared/icons/SettingsDotsIcon';
import { COUNTRY_CODES } from "../../../_geograffee/dafes/pages/CountryShowcase";
import { ChannelDefault } from './components/ChannelDefault';

import {
  CONTEXTS_WHERE_BTNS_HIDDEN,
  DARK_THEME,
  CONTEXT_WHERE_CANNOT_CREATE_PROJECT,
  SUBSCRIPTION_CONTEXTS,
} from './const/misc';
import TeamButtons from './components/TeamButtons';
import LongreadButtons from './components/LongreadButtons';
import TeamTitle from './components/TeamTitle';
import TeamLargeTabs from './components/TeamLargeTabs';
import useTeamTabs from './hooks/useTeamTabs';
import { NotFoundChannel, TeamEditFrameDeletedTeam, TeamEditFrameDraftTeam } from 'shared/components/error-frames';
import TeamDescription from './components/TeamDescription';
import TeamTabs from './components/TeamTabs';
import { useGetDisciplinesTabsFromDisciplines } from 'shared/helpers/LMS/getDisciplinesTabsFromDisciplines';
import TeamEmployeesLink from './components/TeamEmployeesLink';
import getNextItemInArray from "shared/utils/getNextItemInArray";
import { TeamStatusActiveArchived, TeamStatusDeleted, TeamStatusDrafts } from 'shared/helpers/teamsStatus';
import { ChannelsInfo } from 'shared/components/ChannelsInfo/ChannelsInfo';
import { getLowercaseTabs } from './support/getLowercaseTabs';
import { TeamLikesController } from './components/TeamLikesController';
import TeamFeed from '../TeamFeed/TeamFeed';
import { ChannelNavigator } from './components/ChannelNavigator';
import { isContext } from 'vm';
import { ShowCaseViewType } from '../teams/const/showcase';
import useAppTester from 'shared/MobileMenu/hooks/useAppTester';
import { CustomBgWrapper } from 'shared/components/CustomBgWrapper/CustomBgWrapper';

export type TOwnerRights = {
  canMake: boolean;
  teamId: string;
}

const BodyOverflowStyle = createGlobalStyle`
  body {
    overflow-y: scroll !important;t
  }
`

export const ExploreHseContextsNew: FC<{ team: any }> = ({ team }) => {
  const isLMSCourse = team?.moderationType === ModerationType.LMS;
  const { disciplinesRaw, loading: disciplinesLoading } = useGetLMSDisciplines(team?.teamId, !isLMSCourse);
  const isMainPage = !!useRouteMatch(['/'])?.isExact;
  const isMediaMain = isMainPage && AppTester.isContext('mediiia');

  const disciplinesTabs = useGetDisciplinesTabsFromDisciplines(disciplinesRaw)

  const teamWithDisciplines = useMemo(() => ({
    ...team,
    tabs: isLMSCourse ? disciplinesTabs : team?.tabs,
  }), [team, disciplinesTabs])

  const getInitialSorting = useMemo(() => {
    if (isMediaMain) {
      return 1;
    }
    if (AppTester.isMonaLisaTravels()) {
      return 1;
    }
    if (window.location.pathname.startsWith('/teams/') || window.location.pathname.startsWith('/special')) {
      const entityType = team?.mainEntityType;
      if (entityType === 'organizations' || entityType === undefined) {
        return 3;
      } else {
        return 1;
      }
    }
    return undefined;
  }, [team?.mainEntityType]);

  if (disciplinesLoading) {
    return null;
  }

  return <EncodedStateFilter initialSorting={getInitialSorting}>
    <ExploreViewContextsInner team={teamWithDisciplines} />
  </EncodedStateFilter>
};


const ExploreViewContextsInner: FC<{ team: any }> = ({ team }) => {
  const {
    sorting,
    display,
    setDisplay,
    setSorting,
  } = useEncodedStateFilter();

  const {
    isAdcrDafesNet,
    isDeziiign,
    isDeziiignMain,
    isDeziiignContext,
    isDvaDesign,
    isHSEDesign,
    isExamHSE: isExam,
    isIqMediiia: isIqMedia,
    isGeograffee,
    isLectureMediiia: isLectureMedia,
    isGalllleryArt,
    isGeoDafes: isDafes,
    isLMSHSE,
    isSuperPuper,
    isMediiia,
    isProDeziiign: isPro,
    isBooksGallllery: isGalllleryBooks,
    isHseSpace,
    isOnlines,
    isCGRAVE,
    isAcademy,
    isKiiidsArt,
  } = useAppTester();

  const isMain = !!useRouteMatch(['/'])?.isExact;
  const isForcedLanding = !!useRouteMatch(['/brnd', '/teams/:teamName/brnd'])?.isExact
  const isDafesCouncilPage = team?.contextName === 'dafes-council';
  const isMainPage = isMain || isForcedLanding;
  const isDafesMain = isDafes && isMainPage;
  const isTeams = !!useRouteMatch(['/teams/:teamName', '/teams/:teamName/brnd'])
  const isRussianGalllleryRoute = !!useRouteMatch('/teams/russiangallllery')

  const isRussianGallllery = AppTester.isBooksGallllery() && isRussianGalllleryRoute

  const {
    about,
    aboutExtra,
    contextName: context,
    name: mainTitle,
    categories,
    isShowTeachersCheckbox: isShowTeachersCheckboxProp,
    isShowEmployeesLink: contextHasEmployees,
    titleImages,
    ownersIDs,
    teamId,
    isShowLongread,
    isShowGridFirst: isShowGrid,
    mainFilter: mainFilterRaw,
    moderationType,
    mainEntityType,
    status: teamStatus,
    isLongreadDisabled,
    isLinksInsteadTitle,
    topLinks,
    isMinimalName,
    isSortingHidden,
    disciplinesRaw = [],
    isSecondaryTitleHidden
  } = team;

  //todo убрать в одно поле
  const initialView = useMemo(() => {
    if (isShowGrid) {
      return ShowCaseViewType.showcase;
    }
    return ShowCaseViewType.landing;
  }, [isShowLongread, isShowGrid]);

  const isShowGridFirst = initialView === ShowCaseViewType.showcase;

  const location = useLocation();

  const isCompetitions = location.pathname.startsWith(LinkTo.awards);

  const isCountryPage = !!useRouteMatch(LinkTo.country);
  const { id: countryId } = useParams<{ id: string }>();

  //todo вынести в админку
  const mainFilter = useMemo(() => {
    if (isCountryPage) {
      return {
        ...mainFilterRaw,
        countryCode: COUNTRY_CODES[countryId as keyof {}],
      }
    }
    if (isCompetitions) {
      return {
        ...mainFilterRaw,
        competitionStatus: Number(sorting) === 1 ? [1, 4, 3] : [5, 6]
      }
    }
    return mainFilterRaw;
  }, [team, isCountryPage, sorting])

  const hasCategories = !!categories?.length;
  const isTeamRoute = !!useRouteMatch('/teams/:id');

  const { t, i18n, i18n: { language } } = useTranslation();

  const theme = useTheme();
  const isMobile = useIsMobile();
  const is992 = useBreakpoint(992);
  const isTab = useBreakpoint(LayoutConst.screen.l)
  const offset = useScreenOffset();
  const history = useHistory();
  const modal = useModal();
  const profile = useProfile();
  const dispatch = useDispatch();
  const isHseDesignMain = AppTester.isContext('hsedesign');
  const projectsWrapperRef = useRef<HTMLDivElement>(null);

  const isMedia = isMediiia && !isLectureMedia;
  const isDesign = isDeziiign && !isHSEDesign;
  const isVisualResearch = useMemo(() => (context === 'hsevisualresearch'), [context])
  const isManagement = useMemo(() => (context === 'hsemanagement' || context === 'hsestartup'), [context])
  const isAgeytomesh = useMemo(() => (context === 'ageytomesh'), [context])
  const isBooks = AppTester.isBooks() && !AppTester.isBooksMediiia();
  const BookDesign = useMemo(() => (context === 'books_deziiign'), [context])
  const isDarkTheme = useMemo(() => ((!isAgeytomesh && !isHSEDesign && !isDesign && !isDafes) || DARK_THEME.includes(context)) && !BookDesign, [BookDesign, isHSEDesign, context])

  const isCreativeCityUnit = useMemo(() => context === 'creativecityacademy', [context])
  const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile]);
  const isGalleryUnit = teamId === '6b5ada7f08524b33be157c4912b2b60d';
  const isLMSOfline = !!useRouteMatch('/courses_offline');
  const [time, setTime] = useState(Date.now());
  const [isFeed, setIsFeed] = useState(false);

  const { isChannel, channelType } = isTeamChannel(moderationType);

  const {
    tabList,
    titleIsTabs,
    currentCategory,
    currentTab,
    tabs,
    tabsRaw,
    tabColors,
    contextTabs,
    categoryList,
    tabIndex,
    setCurrentTab
  } = useTeamTabs(team)

  const owner = useMemo(
    () => (profile && team && team?.owners?.find(
      (owner: Designer<'Global'>) => owner?.accountId === profile?.accountId) || undefined)
    , [team, isChannel]) as Designer | undefined

  const isChannelParticipant = useMemo(() => {
    if ([ModerationType.ChannelGroupOrCourse, ModerationType.Channel]?.includes(moderationType)) {
      return (ownersIDs?.includes(profile?.accountId) || team?.channelCommentWhiteListIds?.includes(profile?.accountId) || team?.membersIDs?.includes(profile?.accountId))
    }
    return true;
  }, [isChannel, profile, isModer, moderationType])

  const [{ isEmpty, onlyAuthor: channelOnlyAuthorsFilter }, setQueryParams] = useQueryState();

  const isTeamPreview = !!useRouteMatch([LinkTo.previewTeam]);
  const isSpecialProjectsPage = !!useRouteMatch([LinkTo.specialProjects]);
  const isSpecialProjects = isSpecialProjectsPage

  const isIqMain = isMain && isIqMedia;

  const { name: currentModalName } = useSelector(modalControllerSelector);
  const modalIsOpen = useMemo(() => currentModalName !== "", [currentModalName]);

  const [coverPost, setCoverPost] = useState<any>(undefined);
  const [isPostLoaded, setIsPostLoaded] = useState<any>(false);
  const [teamByDate, setTeamByDate] = useState<any>(undefined);

  const visibleLG = useSelector((state: any) => state.vt.longreadVisible);
  const teamHasLongread = (!!team?.longread || !!team?.longreadEntityLink?.length) && !isLongreadDisabled;
  const isLandingPage = teamHasLongread && ((isShowGridFirst && isForcedLanding) || (!isShowGridFirst && !isForcedLanding));
  const shouldDisplayLongread = useMemo(() => (isLandingPage && !isTeamPreview && visibleLG), [visibleLG, isLandingPage, isTeamPreview]);

  const isShowTeachersCheckbox = isChannel || isShowTeachersCheckboxProp

  const isMainPageTeam = (isDvaDesign || isAgeytomesh || isCreativeCityUnit) && isMain;

  const isLMSTeam = useMemo(() => moderationType === ModerationType.LMS, [moderationType])

  const isSuperpuperTeam = context === "superpupergames-mediiia";
  const lowercasedCategoryList = getLowercaseTabs(categoryList)
  const lowercasedTabList = getLowercaseTabs(tabList)
  const currentCategoryList = isSuperpuperTeam ? lowercasedCategoryList : categoryList
  const currentTabList = isSuperpuperTeam ? lowercasedTabList : tabList

  const [teamPageLink, brndLink] = useMemo(() => {
    const basePath = isMainPageTeam ? '' : `/teams/${context || teamId}`
    return [`${basePath}`, `${basePath}/brnd`];
  }, [isLMSTeam, isMainPageTeam, context, teamId])

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isLMSTeam && tabs) {
      setIsLoading(true)
    }
    const timer = setTimeout(() => {
      setIsLoading(false);
    });

    return () => clearTimeout(timer);
  }, [])

  useEffect(() => {
    if (team?.isShowFeed && channelType === ModerationType.Channel) {
      setIsFeed(true);
    }
  }, [team?.isShowFeed, channelType])

  const prevTeam = useSelector(ProjectsGridSelector)?.prevTeam;
  const tabsLoading = useSelector(ProjectsGridSelector)?.tabsLoading;
  const preloadedTabs = useSelector(ProjectsGridSelector)?.tabs;

  const entityType = useMemo(() => {
    const categoryEntityType = categories?.length && categories.find(({ path }: any) => path === currentCategory)?.entityType;
    const tabEntityType = tabs?.length && tabs.find(({
      path,
      category
    }: any) => path === currentTab && (!categories?.length || category === currentCategory))?.entityType;
    return tabEntityType || categoryEntityType || team.mainEntityType;
  }, [team, currentCategory, currentTab, tabs])

  const isLMSRequest = useMemo(() => {
    const tab = tabs.find(({ path }: any) => path === currentTab);
    return mainFilter?.moderationTypes?.includes(3) || tab?.filter?.moderationTypes?.includes(3);
  }, [currentTab])

  const isTeamsEntityType = useMemo(() => entityType === 'organizations' || entityType === undefined, [entityType, isHSEDesign])
  const isModulesEntityType = useMemo(() => entityType === "modules", [entityType]);

  //@ts-ignore
  const isOutsideTextPosition = useMemo(() => (coverPost && coverPost?.titlePosition), [coverPost]);

  const isContextWithoutTabs = !tabs.length || (titleIsTabs && !hasCategories);

  const currentTeam = useGetCurrentTeam();
  const customBGHseSpace = isHseSpace;
  const isTimeLine = context === 'timeline'

  const is430 = useBreakpoint(470);
  const is833 = useBreakpoint(833);
  const is744 = useBreakpoint(LayoutConst.screen.s);
  const is743 = useBreakpoint(LayoutConst.screen.s - 1);

  useEffect(() => {
    if (SUBSCRIPTION_CONTEXTS.includes(team?.contextName) && getCookie(TEAM_SUBSCRIBE_STATUS_SEEN + team?.contextName) !== 'true') {
      modal.show('teamSubscribe', {
        teamName: team?.name, teamContext: team?.contextName, onCustomClose: () => {
          setCookie(TEAM_SUBSCRIBE_STATUS_SEEN + team?.contextName, 'true');
          modal.hide()
        }
      })
    }
  }, [team?.contextName, team?.name])

  const canMakeImageForTeam: TOwnerRights = useMemo(() => profile && team?.ownersIDs?.includes(profile?.accountId) && {
    canMake: team?.ownersIDs?.includes(profile?.accountId),
    teamId: team?.teamId
  }, [team, profile]);

  const vtype = useMemo(() => (team?.longread?.viewType || 't-shape'), [team]);

  const isReplaceLongread = !!team?.longreadType

  const activeTab = useMemo(() => {
    return team?.tabs?.find((tab: any) => tab.path === currentTab)
  }, [currentTab, team])

  const [description, descriptionExtra, tabTitle, tabLinks, isLinksShow] = useMemo(() => {
    const selectedTab = (!!categories?.length && currentCategory)
      ? categories?.find(({ path }: any) => path === currentCategory)
      : currentTab && tabs?.find(({ path }: any) => path === currentTab);

    const showTeamByDateAbout = activeTab?.filter?.useCalendar && !!teamByDate?.about?.length
    const showTeamByDateLinks = !showTeamByDateAbout && activeTab?.filter?.useCalendar && !!teamByDate?.topLinks?.length

    const teamDescription = team?.onlyMainDescription ? team?.about
      : showTeamByDateAbout && teamByDate?.about || (!!selectedTab?.about?.length && selectedTab?.about) || about;
    const teamLinks = showTeamByDateLinks ? (teamByDate?.topLinks || []) : selectedTab?.topLinks || [];
    const showteamLinks = showTeamByDateLinks ? true : (selectedTab?.isLinksShow ?? false)

    return [
      teamDescription, // description
      (!!selectedTab?.aboutExtra?.length && selectedTab?.aboutExtra) || aboutExtra, // description
      selectedTab?.name || '', // tabTitle
      teamLinks, // tabLinks
      showteamLinks, // isLinksShow

    ];
  }, [tabs, about, currentTab, currentCategory, categories, teamByDate, language, activeTab]);

  const showLinks = useMemo(() => {
    return isLinksInsteadTitle || isLinksShow
  }, [isLinksInsteadTitle, isLinksShow])

  const isFinalyShowLinks = useMemo(() => !showLinks, [showLinks]);

  const computeLinks = useMemo(() => {
    if (isLinksInsteadTitle) {
      return topLinks
    } else {
      return tabLinks
    }
  }, [showLinks, topLinks, tabLinks])

  const gridTitleBlock = useMemo(() => {
    const tab = tabs.find(({ path }: any) => path === currentTab);
    if (tab?.gridTitle?.length) {
      if (tab?.gridTitleLink?.length) {
        return (
          <NeutralLinkBasic href={tab.gridTitleLink} target="_blank">
            <GridTitle title={tab.gridTitle} />
          </NeutralLinkBasic>
        )
      }
      return <GridTitle title={tab.gridTitle} />
    }
    return null;
  }, [currentTab, language])

  const [extraFilter, onExtraFilterChange] = useExtraFilter(!isShowTeachersCheckbox);

  const replacedGlobalTypeFilter = useMemo(
    () => (extraFilter.globalType?.includes('student') ? {} : extraFilter), [extraFilter]);

  const serialzeTab = useMemo(() => {
    return isContextWithoutTabs && (!titleIsTabs || hasCategories) ? 'all' : currentTab
  }, [currentTab, titleIsTabs, isContextWithoutTabs])

  const tabLoading = tabsLoading?.[currentCategory]?.[serialzeTab];

  const ParamWithoutContext = useMemo(() => !mainFilter?.contexts?.length, [team]);

  const isLMSCourse = team?.contexts && team?.moderationType === ModerationType.LMS

  const onChannelOnlyAuthorsFilterChange = (value: boolean) => {
    setQueryParams({ onlyAuthor: value }, { replace: true })
  }

  const hasTeamsInitialSorting = useMemo(() => {
    return isTeamsEntityType && !isLMSRequest
  }, [isTeamsEntityType, isLMSHSE])

  const defaultProjectStatus = useMemo(() => {
    if (isExam) {
      return [1, 10];
    }
    return [1];
  }, [])

  const projectsButchFilter = useMemo(() => {
    const baseFilter = {
      ...(!isCompetitions && {
        projectFilter: hasTeamsInitialSorting ? 3 : convertSorting(sorting, {
          isHSEDesign,
          isOnlines,
          isSuperPuper,
          isAgeytomesh,
          isDeziiign,
          isPro,
          isTeam: teamId,
          isLMSRequest,
          isLMSOfline
        })
      }),
      isLite: true,
      limit: offset,
      ...mainFilter,
      projectStatus: mainFilter?.projectStatus?.length ? mainFilter.projectStatus : defaultProjectStatus,
      ...replacedGlobalTypeFilter,
      requestContext: context,
      sort: sorting,
      ...(isExam && {
        globalTypes: [],
      }),
    };



    baseFilter.hasProductCards = Number(sorting) === Number(SortingTypeIndex.shop);

    return baseFilter;
  }, [
    sorting,
    currentTeam,
    replacedGlobalTypeFilter,
    isAgeytomesh,
    isVisualResearch,
    isSuperPuper,
    isManagement,
    ParamWithoutContext,
    convertSorting,
    isHSEDesign,
    isOnlines,
    isDeziiign,
    context,
    mainFilter,
    isLMSHSE,
    currentTab,
    isTeamsEntityType,
    isCompetitions
  ]);

  useEffect(() => {
    if (isChannel ? (prevTeam !== teamId) : (prevTeam !== context)) {
      // if (!disciplinesLoading) {
      dispatch(ProjectsGridActions.setTabs({
        tabs: tabsRaw,
        categories,
        mainEntityType,
        mainFilter,
        context,
      }))
      // }
    }
  }, [context, teamId, prevTeam, tabsRaw, isChannel])

  useEffect(() => {
    if (isLandingPage) {
      setVisibleLG(isLandingPage)
    }
  }, [context, isLandingPage])

  useEffect(() => {
    if (team?.membersIDs?.includes(profile?.accountId) || team?.ownersIDs?.includes(profile?.accountId)) {
      setVisibleLG(false)
    }
  }, [])



  const shouldHideTabs = useMemo(
    () => isTimeLine || isEmpty || (isMedia && isBooks)
    , [context, isEmpty, isSpecialProjects, isMedia, isTimeLine, isBooks, is430]);

  const shouldVisibleMobileTabs = useMemo(() => {
    return ((((isMedia && !isSpecialProjects) || isLectureMedia) && isTab && !isEmpty) || (!isContextWithoutTabs && !titleIsTabs && isTab))
  }, [
    isTab, isSpecialProjects, isContextWithoutTabs, isEmpty, isMobile, titleIsTabs]);
  const shouldVisibleMobileTabsOrTeamLink = useMemo(() => (!shouldHideTabs && (shouldVisibleMobileTabs || (contextHasEmployees && isMobile))), [contextHasEmployees, shouldVisibleMobileTabs, isMobile, shouldHideTabs]);

  useEffect(() => {
    if (teamHasLongread && vtype) {
      dispatch(setType(vtype))
    }
  }, [teamHasLongread, dispatch, vtype])

  const setVisibleLG = (value: boolean) => {
    dispatch(setTeamLongread(value))
  }

  useEffect(() => {
    if (team && teamHasLongread) {
      API.request()
        .endpoint(Endpoints.longread)
        .url('api/post/GetMany')
        .addQuery('idUser', '2')
        //@ts-ignore
        .addQuery('idLongread', isReplaceLongread ? team?.replaceLongreadId : team?.longreadId)
        .get()
        .send()
        .then((r) => r.json())
        .then((r) => {
          setCoverPost(r?.filter((i: any) => i?.style === 'as_cover')[0])
          setIsPostLoaded(true)
        })
    }
  }, [teamHasLongread, team?.replaceLongreadId, team?.longreadId, isReplaceLongread])

  const onSortingChange = useCallback((s: SortingTypeIndex): void => {
    setSorting(s);
  }, [setSorting]);

  const showShop = isGalllleryArt || isDeziiignMain || isHSEDesign || isAcademy || isMediiia || isDafes || isKiiidsArt;

  const sortingMethods = useMemo(() => {
    const shopMethod = showShop ? [30] : [];

    if (isCompetitions) {
      return [1, 2]
    }
    if (isVisualResearch) {
      return [1, 2, 13, 20]
    }
    if (isLMSRequest) {
      return [1, 10, 9]
    }
    if (isLMSOfline) {
      return [10, 9, 3, 0]
    }
    if (isTeamsEntityType) {
      // Показываем сортировки медиа каналов только на табе edu-channels
      return [3, 4, 5];
    }
    if (isDeziiignContext) {
      return [1, 2, 26, ...shopMethod];
    }
    return [1, 2, 26, 20, ...shopMethod];
  }, [isLMSRequest, isVisualResearch, isHSEDesign, showShop, isTeamsEntityType, isMedia])

  // useEffect(() => {
  //   const storedSorting = localStorage.getItem('brg_sorting');
  //   if (storedSorting === String(SortingTypeIndex.shop) && !showShop) {
  //     localStorage.removeItem('brg_sorting');
  //     setSorting(SortingTypeIndex.relevant);
  //   }
  // }, [showShop, setSorting]);

  const prevIsTeamsEntityType = useRef(isTeamsEntityType);
  const prevCurrentTab = useRef(currentTab);
  const prevIsMedia = useRef(isMedia);

  useEffect(() => {
    const isEntityTypeChanged = prevIsTeamsEntityType.current !== isTeamsEntityType;
    const isTabChanged = prevCurrentTab.current !== currentTab;
    const isMediaChanged = prevIsMedia.current !== isMedia;

    if (isEntityTypeChanged) {
      if (isTeamsEntityType) {
        const defaultValue = sortingMethods[0];
        setSorting(defaultValue);
      } else {
        setSorting(SortingTypeIndex.relevant);
      }
      prevIsTeamsEntityType.current = isTeamsEntityType;
    } else if (isTeamsEntityType && (isTabChanged || isMediaChanged)) {
      const defaultValue = sortingMethods[0];
      setSorting(defaultValue);
    } else if (isTeamsEntityType && !sortingMethods.includes(Number(sorting))) {
      const defaultValue = sortingMethods[0];
      setSorting(defaultValue);
    }

    prevCurrentTab.current = currentTab;
    prevIsMedia.current = isMedia;
  }, [isTeamsEntityType, currentTab, isMedia, setSorting, sorting, sortingMethods]);

  const teamLink = useMemo(() => {
    return <TeamEmployeesLink team={team} />
  }, [team])
  const tabsGroup = useMemo(() => {
    return <TeamTabs
      team={team}
      tabList={currentTabList}
      tabColors={tabColors}
      setCurrentTab={setCurrentTab}
      currentTab={currentTab}
      contextTabs={contextTabs}
      tabIndex={tabIndex}
      titleIsTabs={titleIsTabs}
      isLoading={isLMSTeam ? isLoading : false}
      isContextWithoutTabs={isContextWithoutTabs}
    />
  }, [team, tabList, tabColors, setCurrentTab, currentTab, contextTabs, tabIndex, titleIsTabs, isLoading, isContextWithoutTabs])

  const hasTeamEmblem = useMemo(
    () => ((!!team?.titleImages?.length && !!team?.isShowTeamEmblem) || [ModerationType.ChannelGroupOrCourse, ModerationType.Channel]?.includes(channelType))
    , [team, channelType]);

  const activeTabHasImage = !!activeTab?.titleImages?.length;
  const dayTeamHasImage = activeTab?.filter?.useCalendar === true && teamByDate && !!teamByDate?.titleImages?.length

  // получаем организацию по календарю
  const getCurrentDate = () => {
    const now = new Date();
    return {
      day: now.getDate(),
      month: now.getMonth() + 1
    };
  };

  useEffect(() => {

    if (activeTab?.filter?.useCalendar === true) {
      const { day, month } = getCurrentDate();

      API.request()
        .endpoint(Endpoints.geograffee)
        .url('api/Team/GetByDate')
        .addQuery('day', day.toString())
        .addQuery('month', month.toString())
        .get()
        .send()
        .then((r) => r.json())
        .then((data) => {
          console.log('Team by date data:', data);
          setTeamByDate(API.toLang(data, language));
        })
        .catch((error) => {
          console.error('Error fetching team by date:', error);
        });
    }
  }, [activeTab?.filter?.useCalendar, currentTab, language]);

  const shouldDisplayEmblem = useMemo(() => (hasTeamEmblem || activeTabHasImage || dayTeamHasImage || (isDafesMain)), [hasTeamEmblem, activeTabHasImage, isDafesMain, dayTeamHasImage]);

  const onMobileSortingClick = useCallback(() => {
    const nextSorting = getNextItemInArray(Number(sorting), sortingMethods)
    setSorting(nextSorting)
  }, [sorting, setSorting, sortingMethods]);

  const teamButtons = useMemo(() => {
    const showTeamByDateButtons = activeTab?.filter?.useCalendar && !!teamByDate && !!teamByDate?.buttons?.length

    return <TeamButtons team={showTeamByDateButtons ? teamByDate : team} disciplinesRaw={disciplinesRaw} currentTab={currentTab} />;
  }, [team, disciplinesRaw, language, teamByDate, activeTab])

  const btnWrapper = useMemo(() => {

    const isButtons = !((is430 || CONTEXTS_WHERE_BTNS_HIDDEN.includes(context))
      && (!is430 || CONTEXT_WHERE_CANNOT_CREATE_PROJECT.includes(context))
      && CONTEXTS_WHERE_BTNS_HIDDEN.includes(context))

    if (
      (isMobile || isContextWithoutTabs || titleIsTabs)
      && (is430 || CONTEXTS_WHERE_BTNS_HIDDEN.includes(context))
      && (!is430 || CONTEXT_WHERE_CANNOT_CREATE_PROJECT.includes(context))
      && CONTEXTS_WHERE_BTNS_HIDDEN.includes(context) && !isDafesMain
    ) return null;

    if (!teamButtons && !tabsGroup) return null;

    if (isTab && !isDafesMain) return <>{teamButtons}</>

    return (
      <ButtonWrapper
        className='team-button-wrapper'
        hasTabsGroup={!!tabsGroup}
        isButtons={isButtons}
      >
        {teamButtons}
        {!(isDafesMain && is743) && tabsGroup}
      </ButtonWrapper>
    )
  }, [
    tabsGroup,
    isMobile,
    context,
    t,
    i18n.language,
    is430,
    isContextWithoutTabs,
    teamButtons,
    isTab,
    is743,
    isEmpty, titleIsTabs, is833, owner,
    isTeamPreview, profile, isAgeytomesh,
    currentTab, shouldDisplayEmblem,
    isForcedLanding, teamHasLongread]);


  const LgButtons = useMemo(() => {
    if (teamHasLongread) {
      return <LongreadButtons team={team} disciplines={disciplinesRaw} currentTab={currentTab} />
    }
  }, [teamHasLongread, language, currentTab])

  const searchBar = useMemo(
    () => (
      <ProjectsSearchBar
        isLoading={false}
        isCategoriesHidden={true}
        sorting={sorting}
        onSortingChange={onSortingChange}
        sortingMethods={sortingMethods}
        hideLeftBar
        isChannel={isChannel}
        hideRightBar={!isTeamsEntityType}
        hideRightButtons
        extraFilter={isChannel ? channelOnlyAuthorsFilter : extraFilter}
        onExtraFilterChange={isChannel ? onChannelOnlyAuthorsFilterChange : isShowTeachersCheckbox ? onExtraFilterChange : undefined}
        display={flipDisplay(display)}
        onDisplayChange={() => {
          setDisplay(flipDisplay(display));
        }}
        isCompetitions={isCompetitions}
      />
    ),
    [
      display,
      sorting,
      onSortingChange,
      sortingMethods,
      setDisplay,
      extraFilter,
      onExtraFilterChange,
      isShowTeachersCheckbox,
      isMobile,
      ParamWithoutContext,
      isChannel,
      isForcedLanding,
      isTeamsEntityType,
    ],
  );

  const mobileLikeBar = useMemo(() => {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {contextHasEmployees && teamLink}
        {team?.showQu && (
          <FlexBox align='center'>
            <TeamLikesController
              entityId={team?.teamId}
              entityType="team"
            />
          </FlexBox>
        )}
      </div>
    )
  }, [team, contextHasEmployees, teamLink])

  const mobileSortingText = useMemo(() => {
    if (isTeamsEntityType) {
      if (sortingMethods.includes(Number(sorting))) {
        const sortingKey = Number(sorting) === 3 ? 'organizations_created' :
          Number(sorting) === 4 ? 'organizations_popular' :
            Number(sorting) === 5 ? 'organizations_popular_last_period' : '';
        return t(`sorting_type.${sortingKey}`)
      }
      return '';
    }
    return t(`sorting_type.${Number(sorting) === 1 ? 'latest' : Number(sorting) === 10 ? 'price_inc' : Number(sorting) === 9 ? 'price_dec' :
      Number(sorting) === 2 ? 'rating' : Number(sorting) === 26 ? 'popular' : Number(sorting) === 20 ? 'relevant' : Number(sorting) === 30 ? 'shop' : 'score'}`)
  }, [sorting, currentTab, isTeamsEntityType, sortingMethods, t])

  const MobileSearchBar = useMemo(
    () => (
      <MobileFilterRow
        style={{
          justifyContent: isMinimalName && !shouldVisibleMobileTabsOrTeamLink ? 'space-between' : 'flex-end',
          flexDirection: is743 && isMinimalName && !shouldVisibleMobileTabsOrTeamLink ? 'column' : 'row',
          alignItems: is743 && isMinimalName && !shouldVisibleMobileTabsOrTeamLink && 'flex-end',
          width: '100%'
        }}
      >
        {isMinimalName && !shouldVisibleMobileTabsOrTeamLink && <MinimalTitleName>{mainTitle}</MinimalTitleName>}
        <FlexBox>
          {!isMobile && !isTab && !shouldVisibleMobileTabs && contextHasEmployees && teamLink}
          {((isTab) && !(isLMSCourse || isLMSHSE)) ? (
            <>
              {!team?.showQu && is743 && contextHasEmployees && teamLink}
              {!is743 && (
                <>
                  {mobileLikeBar}
                  {team?.showQu && <span style={{ margin: '0 16px', color: '#909090' }}>|</span>}
                </>
              )}
              {!isModulesEntityType && <MobileFilterSort isLectureMedia={isLectureMedia} onClick={onMobileSortingClick}>
                <SortIcon />
                {mobileSortingText}
              </MobileFilterSort>}
            </>
          ) : (
            !(isLMSCourse || isLMSHSE) && <ProjectSearchBarSorting
              selectedSorting={sorting ?? 1}
              onSortingChange={onSortingChange}
              sortingMethods={sortingMethods}
              isCompetitions={isCompetitions}
            />
          )}
        </FlexBox>

      </MobileFilterRow>
    ), [isMobile, modal, isTab, mobileSortingText, context, onMobileSortingClick, sorting, onSortingChange, shouldVisibleMobileTabsOrTeamLink, isModulesEntityType, isLectureMedia, team?.showQu, is743, contextHasEmployees, teamLink, mobileLikeBar, isLMSCourse, isLMSHSE, sortingMethods, isCompetitions, isMinimalName, mainTitle])

  const sortBar = useMemo(
    () => {
      if (isSortingHidden || shouldHideTabs || isDafesCouncilPage || isLMSOfline) return null;

      return (
        <SearchBarBox justifyMobile={isMinimalName ? 'space-between' : 'flex-end'} direction='row'>
          {isTab ? MobileSearchBar : (
            <FlexBox className={'search-box'}>
              {contextHasEmployees && teamLink}
              {team?.showQu && (
                <FlexBox align='center'>
                  <TeamLikesController
                    entityId={team?.teamId}
                    entityType="team"
                  />
                  {!isModulesEntityType && <span style={{ margin: '0 16px', color: '#909090' }}>|</span>}
                </FlexBox>
              )}
              {isTeamsEntityType ? (
                <OrganizationsSorting
                  selectedSorting={sorting}
                  onSortingChange={onSortingChange}
                  sortingMethods={sortingMethods}
                  isDarkTheme={isDarkTheme}
                  isCompetitions={isCompetitions}
                />
              ) : isModulesEntityType ? null : (
                <ProjectSearchBarSorting
                  selectedSorting={sorting}
                  onSortingChange={onSortingChange}
                  sortingMethods={sortingMethods}
                  isDarkTheme={isDarkTheme}
                  isCompetitions={isCompetitions}
                />
              )
              }
            </FlexBox>
          )}
        </SearchBarBox>
      )

    }, [
    isMobile,
    MobileSearchBar,
    isDafesMain,
    contextHasEmployees,
    isMedia,
    currentTab,
    isDafesCouncilPage,
    isTab,
    sorting,
    onSortingChange,
    isVisualResearch,
    shouldHideTabs,
    currentCategory,
    team,
    isLMSOfline,
    isModulesEntityType]
  );


  const canEditTeamEmblem = useMemo(() => {
    if (TeamStatusActiveArchived(team)) return false

    return (!!owner && hasTeamEmblem);
  }, [owner, hasTeamEmblem]);

  const titleClickableProps = useMemo(
    () => (
      teamHasLongread ? {
        isCliclable: true, onClick: () => {
          history.push(isShowGridFirst ? brndLink : teamPageLink);
          setVisibleLG(!visibleLG);
        }
      } : {}), [teamHasLongread, brndLink, teamPageLink, visibleLG])


  const teacherCheckbox = useMemo(() => {
    return (
      <FlexBox
        className={'teacher-checkbox'}
        style={{
          justifyContent: 'flexStart',
          marginBottom: is744 ? 0 : isTab ? 26 : 0,
          width: isTab ? '100%' : 'auto',
          ...(is744 ? { order: 1 } : {}),
          ...(isTab ? { alignItems: 'flex-end' } : {}),
          ...(shouldDisplayEmblem ? { marginTop: isTab ? 0 : 10 } :
            { marginTop: is744 ? 0 : isTab ? 18 : 10, }
          )
        }}
      >
        {searchBar}
      </FlexBox>
    )
  }, [searchBar, isTab, is744])

  const renderButtonsBlock = isDafesMain && isTab ? null : btnWrapper && shouldDisplayEmblem && ((!isShowTeachersCheckbox && !isTab) || !is743)

  const shouldDisplayButtonsBox = useMemo(() => {
    return !(shouldDisplayEmblem && isTab && !is743) || (!btnWrapper && !isShowTeachersCheckbox && (isGalleryUnit || context === 'amschoolportfolio' || is743))
  }, [shouldDisplayEmblem, isTab, is743, btnWrapper, isShowTeachersCheckbox, isGalleryUnit, context])

  const [projectSource, isProjectLoading, projectError] = useProject(team?.replaceLongreadId, i18n.language, team?.replaceLongreadId + time);

  const handleTeamEdit = () => history.push(CreateLinkTo.teamEdit(teamId ?? "undefined"));

  const titleGroup = useMemo(() => {
    return <TeamTitle
      team={team}
      onClick={titleClickableProps}
      tabList={tabList}
      currentTab={currentTab}
    />;
  }, [isChannel, currentTab, tabList, titleClickableProps, team])

  if (shouldDisplayLongread && !coverPost && !isPostLoaded) {
    return <LoaderSpinner />
  }

  if (isChannel && TeamStatusDeleted(team)) {
    return (
      <TeamEditFrameDeletedTeam id={team?.owners?.[0]?.designerId} />
    )
  }

  if (isChannel && TeamStatusDrafts(team)) {
    return (
      <TeamEditFrameDraftTeam
        owner={owner}
        teamId={team?.teamId}
      />
    )
  }

  // if (!isNotAGroupChannelParticipant) {
  //   return (
  //     <NotFoundChannel id={''} />
  //   )
  // }

  if (isChannel && isFeed) {
    return (
      <CoreContainer>
        <ChannelsInfo
          team={team}
          onToggle={setIsFeed}
          isFeed={isFeed}
        />
        {titleGroup}
        {<TeamFeed team={team} />}
      </CoreContainer>
    )
  }

  if (shouldDisplayLongread && !!coverPost && !!isOutsideTextPosition) {
    return (
      <TeamLgView
        teamTags={team?.tags}
        managedTags={team?.managedTags}
        team={team}
        //@ts-ignore
        color={isReplaceLongread ? projectSource?.additionalInfo?.color : team?.additionalInfo?.color}
        //@ts-ignore
        additionalContent={isReplaceLongread ? projectSource?.additionalContent : team?.additionalContent}
        isModer={true}
        buttons={LgButtons}
        title={coverPost}
        titleVisible={isOutsideTextPosition === 'outside'}
        projectSource={projectSource}
      />
    )
  }

  return (
    <CustomBgWrapper backgroundColor={isRussianGallllery? '#E7E7E7' : ''}>
      <CoreContainer
        isCGRAVE={isCGRAVE}
        minOffset={isIqMain || isCGRAVE}
      >
        {isTeams && (
          <MetaTags
            title={`${isMedia ? 'Mediiia | ' : ''}${mainTitle}`}
            description={[description]}
            images={titleImages}
          />
        )}
        {!modalIsOpen && <BodyOverflowStyle />}
        {(isMedia || isLectureMedia || customBGHseSpace || isGalllleryArt) && <GlobalChangeColorWrapper />}
        <FlexBox direction="column" directionMobile="column" flex="1">
          <div style={{ position: 'relative' }}>
            {showLinks && (
              <FlexBox direction={shouldDisplayEmblem ? 'row' : 'column'} directionMobile={'row'}
                  justify={shouldDisplayEmblem ? 'space-between' : 'flex-start'}>
                <TopLinksList topLinks={computeLinks} />
                {shouldDisplayEmblem && !is743 && (
                        <>
                          {!isDafesMain ? (
                            <EmblemContainer
                              team={activeTab?.filter?.useCalendar === true && teamByDate || team}
                              owner={owner}
                              canEditEmblem={canEditTeamEmblem}
                              currentTab={currentTab}
                            />
                          ) : (<InteractiveEmblem currentTab={currentTab} />)}
                        </>
                  )}
              </FlexBox>)}
            {isChannel && <ChannelsInfo team={team} onToggle={setIsFeed} />}
            {isFinalyShowLinks && (
              <>
                <FlexBox direction={shouldDisplayEmblem ? 'row' : 'column'} directionMobile={'row'}
                  justify={shouldDisplayEmblem ? 'space-between' : 'flex-start'}>
                  <FlexBox direction={'column'} directionMobile='column' width={'100%'}>
                    <TeamLargeTabs
                      team={team}
                      currentCategory={currentCategory}
                      currentTab={currentTab}
                      categoryList={currentCategoryList}
                      tabList={tabList}
                      tabsRaw={tabs}
                    />
                    {titleGroup}
                    <ChannelNavigator channel={team} />
                    <BottomGroupWrapper
                      className='explore-view_bottom-group-wrapper'
                      justifyBetween={shouldDisplayEmblem && !is833}
                      titleIsTabs={titleIsTabs}
                      disableOffset={(isDesign || isGeograffee) && is430 && !isAgeytomesh}
                      disabledTabs={shouldDisplayEmblem}
                      disableButtons={isShowTeachersCheckbox}
                      hasEmblem={shouldDisplayEmblem}
                      isMedia={isMedia}
                      teamButtons={!!teamButtons}
                    >
                      <TeamDescription team={team} description={description} fillButtonsSpace={!renderButtonsBlock} />
                      {renderButtonsBlock && btnWrapper}
                    </BottomGroupWrapper>

                  </FlexBox>
                  {shouldDisplayEmblem && !is743 && (
                    <>
                      {!isDafesMain ? (
                        <EmblemContainer
                          team={activeTab?.filter?.useCalendar === true && teamByDate || team}
                          owner={owner}
                          canEditEmblem={canEditTeamEmblem}
                          currentTab={currentTab}
                        />
                      ) : (<InteractiveEmblem currentTab={currentTab} />)}
                    </>
                  )}
                </FlexBox>
              </>
            )}

            {(isModer || !!owner) && isTeams && !isChannel && !isMinimalName && <SettingsDotsWrapper shouldDisplayEmblem={shouldDisplayEmblem && !is743}>
              <Dropdown
                offsetY={8}
                offsetX={0}
                hideArrow
                orientation='right'
                target={
                  <SettingsDotsIcon />
                }
              >
                <DropdownListItemTeamEdit theming={theme.navigationBar.login} onClick={handleTeamEdit}>{t('edit-organization')}</DropdownListItemTeamEdit>
              </Dropdown>
            </SettingsDotsWrapper>}

          </div>

          {isLMSTeam && <NearLessonBlock teamId={teamId} />}
          <BottomOuterContainer
            className='explore-view_bottom-outer-container'
            directionMobile={'column'}
            direction={'column'}
            {...(isHseDesignMain && isTab && { direction: 'column' })}
            justify="space-between"
            align={'flex-end'}
            disabledOffset={isMinimalName}
            disabledTabs={(shouldDisplayEmblem && !isShowTeachersCheckbox && !showLinks) || isEmpty}
            disableGap={shouldDisplayEmblem || !isShowTeachersCheckbox || isMinimalName}
            isLMSTeam={isLMSTeam}
            isChannel={isChannel}
            visibleMobileTabs={shouldVisibleMobileTabsOrTeamLink}
            style={{ display: shouldHideTabs ? 'none' : 'flex' }}
            gy={isTab ? 24 : 32}
            isGalllleryBooks={isGalllleryBooks}
            teamButtons={!!teamButtons}
          >
            {isShowTeachersCheckbox && is744 && teacherCheckbox}

            {shouldDisplayButtonsBox && (
              <FlexBox width={'100%'}>
                <ButtonsBox className='explore-view_buttons-box' align={isShowTeachersCheckbox ? 'baseline' : 'center'} >
                  {btnWrapper}
                  {isMinimalName && (!isTab || is743) && <MinimalTitleName>{mainTitle}</MinimalTitleName>}

                  {(isModer || !!owner) && isTeams && !isChannel && isMinimalName && !isMobile && <SettingsDotsWrapper isMinimalName={isMinimalName} shouldDisplayEmblem={shouldDisplayEmblem && !is743}>
                    <Dropdown
                      offsetY={8}
                      offsetX={0}
                      hideArrow
                      orientation='right'
                      target={
                        <SettingsDotsIcon />
                      }
                    >
                      <DropdownListItemTeamEdit theming={theme.navigationBar.login} onClick={handleTeamEdit}>{t('edit-organization')}</DropdownListItemTeamEdit>
                    </Dropdown>
                  </SettingsDotsWrapper>}
                  {
                    (isShowTeachersCheckbox && !is744) ||
                    (!isTab && !isSortingHidden) &&
                    <FlexBox
                    className={isSuperpuperTeam ? '' : 'js-right-side-box'}
                    direction='column'
                    width={isTab ? '100%' : 'auto'}
                    style={{ height: '100%', rowGap: isShowTeachersCheckbox ? 32 : /*70*/ 0 }}
                    justify='space-between'
                    align='flex-end'
                  >
                    {isShowTeachersCheckbox && !is744 ? teacherCheckbox : <div />}
                    {!isTab && !isSortingHidden && sortBar}
                  </FlexBox>
                  }
                </ButtonsBox>
              </FlexBox>)}

            {isTab && !isAdcrDafesNet && (
              <MobileTabsContainer className='explore-view_mobile-tabs-container' hasLikes={is743 && team?.showQu}>
                {isMinimalName && shouldVisibleMobileTabsOrTeamLink && <MinimalTitleName>{mainTitle}</MinimalTitleName>}
                {is743 && team?.showQu && (
                  <div style={{ marginBottom: 24 }}>
                    {mobileLikeBar}
                  </div>
                )}
                <MobileTabsBox>
                  {(shouldDisplayEmblem && !is744) && isShowTeachersCheckbox && teacherCheckbox}
                  <FlexBox
                    widthMobile={'100%'}
                    width={'100%'}
                    justify={isTab ? 'space-between' : 'flex-end'}
                    {...(!isShowTeachersCheckbox && isFinalyShowLinks && { ...(is744 && !is743 && { offsetBottomMobile: 26 }) })}
                  >
                    {isDafesMain && !is743 ? btnWrapper : shouldVisibleMobileTabsOrTeamLink && tabsGroup}
                    {!isSortingHidden && sortBar}
                  </FlexBox>
                </MobileTabsBox>
              </MobileTabsContainer>

            )}
          </BottomOuterContainer>
          {gridTitleBlock}
          {!isEmpty && (
            <ProjectControllerWrapper
              ref={projectsWrapperRef}
              isTeamRoute={isTeamRoute}
            >
              <ProjectsButchController
                filter={projectsButchFilter}
                currentCategory={currentCategory}
                currentTab={serialzeTab}
                contextName={context}
                channelOwnerId={channelOnlyAuthorsFilter ? owner?.accountId : undefined}
                isChannel={isChannel}
                isChannelParticipant={isChannelParticipant}
                teamId={teamId}
                emptyMsgText={isLMSHSE ? t('empty_category_new') : undefined}
                {...isMedia && is743 ? { mobileColumns: 1 } : {}}
                canMakeImageForTeam={canMakeImageForTeam}
                isMainPage
              />
            </ProjectControllerWrapper>
          )}
        </FlexBox>
        {!!descriptionExtra?.length && (
          <DescriptionExtra preLine>
            {descriptionExtra}
          </DescriptionExtra>
        )}
        {!isChannel && !isSecondaryTitleHidden && <TeamBottomInfo
          title={titleGroup}
          buttons={teamButtons}
        />}
      </CoreContainer>
    </CustomBgWrapper>
  );
};

export default ExploreHseContextsNew;
